// extracted by mini-css-extract-plugin
export default {"efficiencySkeleton":"efficiency-skeleton_efficiencySkeleton__Lu8iA","title":"efficiency-skeleton_title__FsXQ8"};